import { errorHandler } from "./errorHandler";
import { apiRequest } from "./apiRequest";

export const enableScraping = async (): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "post",
      `/scrape-websites`
    );

    return data.message;
  } catch (error) {
    console.error("Error in enabling scraping:", error);
    errorHandler(error);
    throw new Error("Failed to update all");
  }
};
